{
  "comu": {
    "revisaErrors": "Revisa els camps marcats en vermell"
  },
  "zones": {
    "cerca": "Cerca per nom, codi o adreça…",
    "inactives_one": "Mostra inactives ({{count}})",
    "inactives_other": "Mostra inactives ({{count}})",
    "buit": "Encara no hi ha cap zona. Crea la primera amb «Nova zona».",
    "senseResultats": "Cap zona coincideix amb «{{q}}».",
    "totesInactives": "Totes les zones estan inactives. Activa «Mostra inactives» per veure-les.",
    "novaEtiqueta": "Nova zona",
    "dins": "Es crearà dins de",
    "crea": "Crea la zona",
    "codiFix": "Codi curt i únic. Un cop creada la zona no es podrà canviar.",
    "codiBloquejat": "El codi no es pot canviar perquè altres registres hi fan referència.",
    "ajudaActiu": "Una zona inactiva no es pot triar en activacions noves.",
    "plega": "Plega {{nom}}",
    "desplega": "Desplega {{nom}}",
    "afegeixDins": "Afegeix una zona dins de {{nom}}",
    "nFills_one": "{{count}} zona",
    "nFills_other": "{{count}} zones"
  },
  "integracions": {
    "integracio": "Integració",
    "totesOk": "Totes les integracions funcionen",
    "ambProblemes_one": "{{count}} integració amb problemes",
    "ambProblemes_other": "{{count}} integracions amb problemes",
    "errorMonitoratge": "No s'ha pogut consultar l'estat de les integracions. Torna-ho a provar amb «Comprova ara».",
    "rendiment": "Rendiment dels enviaments",
    "senseDades": "Encara no hi ha dades de monitoratge.",
    "configuracio": "Com està configurada cada integració",
    "senseConfigurar_one": "{{count}} integració sense configurar",
    "senseConfigurar_other": "{{count}} integracions sense configurar"
  },
  "versions": {
    "pestanyaVersions": "Versions",
    "darrera": "Darrera publicada",
    "minima": "Mínima obligatòria",
    "formatVersio": "La versió ha de tenir el format 2, 2.4 o 2.4.1.",
    "rangInvalid": "La versió inicial ha de ser anterior o igual a la final.",
    "ajudaMinima": "Les apps amb una versió anterior hauran d'actualitzar-se per continuar funcionant.",
    "definitiva": "Una versió publicada no es pot modificar ni esborrar: revisa-la abans de publicar.",
    "plataformes": "Plataformes",
    "desde": "Visible des de",
    "fins": "Visible fins a",
    "datesInvalides": "La data final ha de ser posterior a la inicial.",
    "ajudaVigencia": "Deixa les dates buides perquè el missatge es mostri sempre mentre estigui actiu.",
    "triaMissatge": "Tria un missatge per veure com es mostra a l'app.",
    "eliminaTitol": "Eliminar el missatge",
    "eliminaText": "El missatge «{{titol}}» deixarà de mostrar-se a l'app i s'eliminarà. Si només el vols aturar, desactiva'l."
  },
  "configuracio": {
    "pestanyes": {
      "ajustos": "Configuració",
      "historial": "Historial de canvis"
    },
    "regional": "Regional",
    "escalat": "Escalat",
    "ajudaEscalat": "S'aplica als nivells de circuit que no tenen espera pròpia. Cada nivell pot tenir el seu temps i cada tipus d'avís, el seu temps de confirmació:",
    "fusos": {
      "Europe_Madrid": "Península i Balears",
      "Atlantic_Canary": "Canàries",
      "UTC": "Temps universal (UTC)"
    }
  },
  "politica": {
    "ajudaFormats": "Només es podran pujar fitxers d'aquests formats.",
    "midaInvalida": "Indica una mida entre 1 i 500 MB.",
    "maxInvalid": "Indica un nombre enter entre 1 i 1.000.",
    "sempre": "Sempre s'aplica, sigui quina sigui la configuració",
    "noDisponibles": "Fitxers no disponibles"
  },
  "documents": {
    "cerca": "Cerca per títol, codi o categoria…",
    "filtraAmbit": "Filtra per departament, àrea o servei…",
    "treuAmbit": "Treu el filtre d'àmbit",
    "totsFormats": "Tots els formats",
    "document": "Document",
    "perA": "Per a",
    "senseResultats": "Cap document coincideix amb els filtres.",
    "noObrible": "El fitxer no es pot consultar; obre la fitxa per veure'n el motiu.",
    "noDescarregable": "No es pot consultar ni descarregar",
    "nDocuments_one": "{{count}} document",
    "nDocuments_other": "{{count}} documents",
    "perQui": "Per a qui és?",
    "triaServei": "Tria el servei…",
    "quiConsulta": "Qui el pot consultar",
    "ambit": {
      "SERVEI": "Només el servei",
      "AREA": "Tota l'àrea",
      "DEPARTAMENT": "Tot el departament"
    },
    "ambitFrase": {
      "SERVEI": "Només el servei {{nom}}",
      "AREA": "Tota l'àrea {{nom}}",
      "DEPARTAMENT": "Tot el departament {{nom}}"
    },
    "ambitAjuda": {
      "SERVEI": "El veuen les persones amb accés a aquest servei.",
      "AREA": "El veuen les persones amb accés a qualsevol servei de l'àrea.",
      "DEPARTAMENT": "El veuen les persones amb accés a qualsevol àrea del departament."
    },
    "ajudaDescarrega": "Ho decideix la política de fitxers; si no, només es pot consultar amb marca d'aigua.",
    "fitxerIDades": "Fitxer i dades",
    "ajudaTitol": "Si deixes el títol buit, s'usarà el nom del fitxer.",
    "categoriaPlaceholder": "p. ex. Procediment, Contactes…",
    "comentariPlaceholder": "Què ha canviat en aquesta versió (opcional)",
    "novaVersioDe": "La versió nova substituirà la vigent ({{versio}}) quan superi l'anàlisi antimalware.",
    "resultat": "«{{titol}}» s'ha pujat. Es publicarà automàticament quan superi l'anàlisi antimalware.",
    "obreDocument": "Obre el document",
    "pestanyes": {
      "dades": "Dades",
      "versions": "Versions",
      "acces": "Accés",
      "activitat": "Activitat"
    },
    "senseResponsable": "Sense responsable",
    "retiratNoEditable": "Un document retirat no es pot editar. Restaura'l per tornar-lo a publicar.",
    "senseEdicio": "No tens permís per modificar aquest document.",
    "restaura": "Restaura",
    "restauraNoDisponible": "La restauració de documents encara no està disponible.",
    "retiraTitol": "Retirar «{{titol}}»",
    "retiraText": "El document deixarà d'estar disponible a les activacions. L'historial es conserva i el podràs restaurar.",
    "que": "Què",
    "mesActivitat": "Mostra'n més"
  }
}
